import * as React from "react";
const LinkedinLogo = ({ color, ...props }) => (
  <svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.9444 0.5C29.8874 0.5 30.7918 0.874602 31.4586 1.5414C32.1254 2.20819 32.5 3.11256 32.5 4.05556V28.9444C32.5 29.8874 32.1254 30.7918 31.4586 31.4586C30.7918 32.1254 29.8874 32.5 28.9444 32.5H4.05556C3.11256 32.5 2.20819 32.1254 1.5414 31.4586C0.874602 30.7918 0.5 29.8874 0.5 28.9444V4.05556C0.5 3.11256 0.874602 2.20819 1.5414 1.5414C2.20819 0.874602 3.11256 0.5 4.05556 0.5H28.9444ZM28.0556 28.0556V18.6333C28.0556 17.0963 27.445 15.6221 26.3581 14.5353C25.2712 13.4484 23.7971 12.8378 22.26 12.8378C20.7489 12.8378 18.9889 13.7622 18.1356 15.1489V13.1756H13.1756V28.0556H18.1356V19.2911C18.1356 17.9222 19.2378 16.8022 20.6067 16.8022C21.2668 16.8022 21.8998 17.0644 22.3666 17.5312C22.8333 17.998 23.0956 18.631 23.0956 19.2911V28.0556H28.0556ZM7.39778 10.3844C8.18989 10.3844 8.94956 10.0698 9.50967 9.50967C10.0698 8.94956 10.3844 8.18989 10.3844 7.39778C10.3844 5.74444 9.05111 4.39333 7.39778 4.39333C6.60095 4.39333 5.83676 4.70987 5.27331 5.27331C4.70987 5.83676 4.39333 6.60095 4.39333 7.39778C4.39333 9.05111 5.74444 10.3844 7.39778 10.3844ZM9.86889 28.0556V13.1756H4.94444V28.0556H9.86889Z"
      fill={color}
    />
  </svg>
);
export { LinkedinLogo };
